const Constant = {
  defaultApiUrl: process.env.REACT_APP_API_URL || "https://api.ulps.dev.ultinous.com/default",
  replaceDelimiter: '@%%@',
  apiUrl: "@%%@ULPS_API_URL@%%@",
  fileNamePrefix: "licence",

  url: {
    LICENCE_GENERATION: "/licence-generation",
    DISTRIBUTORS: "/distributors",
    FEATURES: "/features",
    FEATURE_GROUPS: "/feature-groups",
    DISTRIBUTOR: "/distributor",
    USERS: "/users",
    NO_PERMISSION: "/no-permission",
    LICENCES_OF_DISTRIBUTOR: "/licence-of-distributor",
    LICENCES: "/licences",
    EDIT_LICENCE: "/licences/edit",
    CREATE_FEATURE: "/feature/create",
    CREATE_FEATURE_GROUP: "/feature-groups/create",
    EDIT_FEATURE_GROUP: "/feature-groups/edit",
    BATCH: "/batch",
    USER_INFO: "/user",
  }
}

Constant.apiUrl = Constant.apiUrl.includes(Constant.replaceDelimiter) ? Constant.defaultApiUrl : Constant.apiUrl;

export default Constant;
